export default __webpack_public_path__ + "static/UI1-8040d679284bcbe33be760e24d97381d.png";